import React from "react";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";

const DashboardWrapper = ({ children }) => {
  return (
    <DashboardLayout>
      <DashboardNavbar />
      {children}
    </DashboardLayout>
  );
};

export default DashboardWrapper;
